import { render, staticRenderFns } from "./secondary-link.vue?vue&type=template&id=b0646170&"
import script from "./secondary-link.vue?vue&type=script&lang=js&"
export * from "./secondary-link.vue?vue&type=script&lang=js&"
import style0 from "./secondary-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports